const TOKEN_KEY = 'ACCESS_XPOST';
const COMPANY_KEY = 'COMPANY_XPOST';
const GATEWAY_KEY = 'maisenvios_gateway';
const REFRESH_TOKEN_KEY = 'refresh_token';
const USER_LOGON = 'user_logon';

// ENTRAR: a aba do admin guarda o token no localStorage (compartilhado entre abas); a aba aberta
// na conta do cliente guarda o token do cliente no sessionStorage (só daquela aba). Assim a sessão
// do admin nunca é sobrescrita e fechar a aba do cliente volta para a conta do admin.
const TokenService = {
    getToken() {
        return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
    },
    isImpersonating() {
        return sessionStorage.getItem(TOKEN_KEY) !== null;
    },
    startImpersonation(accessToken) {
        sessionStorage.setItem(TOKEN_KEY, accessToken);
    },
    endImpersonation() {
        sessionStorage.removeItem(TOKEN_KEY);
    },
    getGateway() {
        return localStorage.getItem(GATEWAY_KEY);
    },
    getCompany() {
        return localStorage.getItem(COMPANY_KEY);
    },
    saveGateway(accessToken) {
        localStorage.setItem(GATEWAY_KEY, accessToken)
    },
    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken);
    },
    saveCompany(companyDb) {
        localStorage.setItem(COMPANY_KEY, companyDb);
    },

    removeToken() {
        if (this.isImpersonating()) {
            return this.endImpersonation();
        }
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(COMPANY_KEY);
        localStorage.removeItem(USER_LOGON);
        localStorage.removeItem(GATEWAY_KEY);
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },

    saveUserLogon(userLogon) {
        localStorage.setItem(USER_LOGON, userLogon);
    },
    getUserLogon() {
        return localStorage.getItem(USER_LOGON);
    },
};

// Sai da conta do cliente: fecha a aba aberta pelo ENTRAR; se o navegador não deixar fechar,
// recarrega a aba já com a sessão do admin.
function leaveImpersonation() {
    TokenService.endImpersonation();
    window.close();
    window.location.replace('/');
}

export { TokenService, leaveImpersonation };

